// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"348":"d3bc4b8e","443":"89ed39c7","620":"8a955b4d","715":"61413069"}[chunkId] + ".css";
};